export const META_DATA_VALUES = {
  private: 'private',
} as const;

export const META_TAGS = {
  private: `<meta content="${META_DATA_VALUES.private}" name="access" />`,
};

export const OIDC_CHECK_INTERVAL_MS = 30000;

export const EXPIRES_AT_SESSION_BUFFER_SEC = 30;

export const OIDC_AUTH_STATUES = {
  authorized: 'COMPLETE',
};

export const OIDC_QUERY_PARAMS = {
  code: 'code',
  state: 'state',
  error: 'error',
};
